import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from 'constants/routes.constant';

type EventType = 'ama' | 'referral' | 'trading' | 'informational';

type UseEventTypeRedirectParams = {
  eventId: string | undefined;
  eventType: EventType | undefined;
  currentRoute: 'ama' | 'referral' | 'event' | 'informational';
  isLoading: boolean;
};

export const getRouteForEventType = (eventType: EventType, eventId: string): string => {
  switch (eventType) {
    case 'ama':
      return `${ROUTES.AMA}/${eventId}`;
    case 'informational':
      return `${ROUTES.INFORMATIONAL}/${eventId}`;
    case 'referral':
      return `${ROUTES.REFERRAL}/${eventId}`;
    case 'trading':
      return `${ROUTES.TRADING_EVENT}/${eventId}`;
    default:
      return `${ROUTES.EVENTS}`;
  }
};

const shouldRedirect = (eventType: EventType, currentRoute: 'ama' | 'referral' | 'event' | 'informational'): boolean => {
  if (eventType === 'ama' && currentRoute !== 'ama') return true;
  if (eventType === 'informational' && currentRoute !== 'informational') return true;
  if (eventType === 'referral' && currentRoute !== 'referral') return true;
  if (eventType === 'trading' && currentRoute !== 'event') return true;
  return false;
};

export const useEventTypeRedirect = ({ eventId, eventType, currentRoute, isLoading }: UseEventTypeRedirectParams) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading || !eventType || !eventId) return;

    if (shouldRedirect(eventType, currentRoute)) {
      const correctRoute = getRouteForEventType(eventType, eventId);
      navigate(correctRoute, { replace: true });
    }
  }, [eventType, eventId, currentRoute, isLoading, navigate]);
};
